import { z } from "zod";


export const FormSchema = z.object({
  supplier_name: z.string().min(1, "O Nome do Fornecedor é obrigatório."),
  supplier_number: z
    .string()
    .min(1, "O Número do Fornecedor é obrigatório.")
    .regex(/^\d+$/, "O Número do Fornecedor deve conter apenas números."),
    cnpj: z
    .string()
    .min(1, "O CNPJ do Fornecedor é obrigatório.")
    .transform((value) => value.replace(/\D/g, "")) 
    .refine((value) => value.length === 14, {
      message: "O CNPJ do Fornecedor deve conter exatamente 14 dígitos numéricos.",
    }),
  
  is_active: z.boolean(),
  type: z.string().min(1, "O Tipo do Fornecedor é obrigatório."),
  business_unit: z.string().min(1, "A Unidade de Negócio é obrigatória."),
  
})